<template>

    <div class="common_layout">

        <TopHeader :title="pageTitle.value"/>

        <div style="padding-left: 32px; padding-right: 32px;">

            <p class="common_font" style="margin-top: 25px;">商品主圖</p>

            <div class="center_flex_layout" style="justify-content: flex-start;">

                <el-upload
                        v-model:file-list="fileList"
                        action="https://test.sancttech.com:8075/file/upload"
                        :headers="uploadImgHead.value"
                        list-type="picture-card"
                        :show-file-list="false"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-success="uploadSuccess"
                        :limit="1"
                        name="multipartFile"
                        :on-exceed="handleExceed"
                        :before-upload="uploadBefore"
                >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <el-icon v-else><Plus /></el-icon>
                </el-upload>

                <el-button v-if="imageUrl" style="margin-left: 10px;" type="danger" icon="Delete" @click="deleteMainImg" circle />

            </div>

            <p class="common_font" style="margin-top: 25px;">商品標題</p>

            <el-input size="large" class="common_font" style="margin-top: 5px;" v-model="goodsTitle.value" placeholder="請輸入商品標題"/>

            <p class="common_font" style="margin-top: 45px;">規格</p>

            <div v-for="(sku, index) in goodsSku.value" :key="index" class="center_flex_layout" style="justify-content: flex-start;">

                <el-input size="large" class="common_font" style="margin-top: 5px;" v-model="sku.name" placeholder="請輸入商品規格"/>

                <el-button type="danger" icon="Delete" style="margin-left: 10px;" @click="deleteSku(sku)" circle />

            </div>

            <el-button plain style="margin-top: 5px;" @click="addSkuInput">添加</el-button>

            <p class="common_font" style="margin-top: 30px;">價格</p>

            <div class="center_flex_layout" style="justify-content: flex-start;">

                <p class="common_font" style="margin-right: 10px;">CNY</p>

                <el-input size="large" class="common_font" style="margin-top: 5px;" v-model="goodsPrice.value" placeholder="請輸入價格"/>

            </div>

            <div class="center_flex_layout" style="margin-top: 89px;">
                <el-button type="primary" style="width: 134px;" size="large" @click="addGoodsData">{{bottomButtonText.value}}</el-button>
            </div>

        </div>

    </div>

</template>

<script setup>

    import {reactive, ref, onMounted, getCurrentInstance} from 'vue';
    import { get,post } from '../../utils/request';
    import { Decrypt } from '../../utils/secret'
    import { ElLoading } from 'element-plus';
    import { useRouter } from "vue-router";
    const router = useRouter();
    const {proxy} = getCurrentInstance();

    const pageTitle = reactive({value: ''});
    const bottomButtonText = reactive({value: ''});
    const dataId = reactive({value: ''});
    const goodsTitle = reactive({value: ''});
    const goodsSku = reactive({value: []});
    const goodsPrice = reactive({value: ''});
    const fileList = ref([]);
    const imageUrl = ref('');
    const upload = ref('');
    const uploadImgHead = reactive({value: ''});
    let loading;

    onMounted(() => {

        //先解码再解密
        if(router.currentRoute.value.query.goodsId){
            const encodedData = JSON.parse(Decrypt(decodeURIComponent(router.currentRoute.value.query.goodsId)));
            // console.log(encodedData);
            pageTitle.value = '編輯商品';
            bottomButtonText.value = '保存';
            dataId.value = encodedData;
            getGoodsDetail();
        } else {
            // console.log('没东西');
            pageTitle.value = '添加商品';
            bottomButtonText.value = '添加';
        };

        uploadImgHead.value = {
            'Authorization': 'Bearer ' + localStorage.access_token,
        }

    });

    const getGoodsDetail =()=> {

        get('/manager/goods/detail?goodsId='+dataId.value, {})
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code === 1){
                    goodsTitle.value = res.result.goodsTitle;
                    goodsPrice.value = res.result.goodsPrice;
                    imageUrl.value = res.result.imgUrl;
                    let skuListArr = res.result.skuList;
                    let addSkuArr = goodsSku.value;
                    skuListArr.forEach((sku, skuIndex) => {
                        let skuObj = {name: sku.specialName, id: Math.floor(skuIndex + 1)};
                        addSkuArr.push(skuObj);
                    })
                }
            })
            .catch(error => {
                console.log(error);
            })

    };

    const handleRemove =(uploadFile, uploadFiles)=> {
        // console.log(uploadFile, uploadFiles);
    };

    const handlePictureCardPreview =(uploadFile)=> {
        // console.log(uploadFile);
    };

    const handleExceed =(files)=> {
        // upload.value.clearFiles();
        // const file = files[0] as UploadRawFile;
        // file.uid = genFileId();
        // upload.value.handleStart(file);
    };

    const uploadBefore =()=> {
        loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
    };

    const uploadSuccess =(file)=> {
        // console.log(JSON.stringify(file));
        imageUrl.value = file.result.url;
        setTimeout(() => {
            loading.close();
        }, 500)
    };

    const addSkuInput =()=> {
        let addSkuArr = goodsSku.value;
        let skuObj = {name: '', id: Math.floor(addSkuArr.length + 1)};
        addSkuArr.push(skuObj);
    };

    const deleteSku =(data)=> {
        // console.log(data);
        let addSkuArr = goodsSku.value;
        addSkuArr = addSkuArr.filter(item => {
            return item.id !== data.id;
        });
        goodsSku.value = addSkuArr;
    };

    const deleteMainImg =()=> {
        fileList.value = [];
        imageUrl.value = '';
    };

    const addGoodsData =()=> {

        if (!imageUrl.value) {
            proxy.$toast('請上傳商品主圖');
            return;
        }

        if (!goodsTitle.value) {
            proxy.$toast('請輸入商品標題');
            return;
        }

        if (goodsSku.value.length === 0) {
            proxy.$toast('請添加商品規格');
            return;
        }

        if (!goodsPrice.value) {
            proxy.$toast('請輸入商品價格');
            return;
        }

        let skuArrData = goodsSku.value;
        let currentSku = [];
        skuArrData.forEach(sku => {
            let singleSkuName = {
                specialName: sku.name,
            };
            currentSku.push(singleSkuName);
        });

        let addGoodsParams = {
            id: dataId.value,
            type: 1,
            goodsTitle: goodsTitle.value,
            imgUrl: imageUrl.value,
            goodsPrice: goodsPrice.value,
            skuList: currentSku,
        };

        // console.log(addGoodsParams);

        post('/manager/goods/handle', addGoodsParams, null)
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code === 1){
                    proxy.$toast(bottomButtonText.value+'成功');
                    router.go(-1);
                }
            })
            .catch(error => {
                console.log(error);
            })

    };

</script>

<style lang="less">

    .el-upload--picture-card .avatar {
        width: 148px;
        height: 148px;
        display: block;
    }

    .el-upload--picture-card {
        width: 148px;
        height: 148px;
        background-color: #FFFFFF!important;
        margin-top: 5px!important;
        border-radius: 4px!important;
        overflow: hidden!important;
    }

</style>